import { CryptoPrice } from "@/lib/crypto";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { TrendingUp, TrendingDown } from "lucide-react";

interface MarketTableProps {
  cryptos: CryptoPrice[];
}

export function MarketTable({ cryptos }: MarketTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Crypto</TableHead>
          <TableHead>Prezzo</TableHead>
          <TableHead>24h</TableHead>
          <TableHead>Market Cap</TableHead>
          <TableHead>Azione</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {cryptos.map((crypto) => (
          <TableRow key={crypto.id}>
            <TableCell className="font-medium">{crypto.symbol}</TableCell>
            <TableCell>${crypto.current_price.toFixed(2)}</TableCell>
            <TableCell>
              <Badge
                variant={
                  crypto.price_change_percentage_24h > 0
                    ? "default"
                    : "destructive"
                }
                className="flex items-center gap-1 w-fit"
              >
                {crypto.price_change_percentage_24h > 0 ? (
                  <TrendingUp className="w-3 h-3" />
                ) : (
                  <TrendingDown className="w-3 h-3" />
                )}
                {crypto.price_change_percentage_24h.toFixed(2)}%
              </Badge>
            </TableCell>
            <TableCell>${(crypto.current_price * 1000000).toFixed(0)}</TableCell>
            <TableCell>
              <button className="text-blue-500 hover:underline text-sm">
                Compra
              </button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
